module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("store_purchase_empty", [["div",{"class":"empty-purchase"},[["textNode",{"text":" This is the page where you will easily be able to find everything you have purchased in my store. To start shopping, check out the "}],["a",{"href":"/store","title":"Store"},[["textNode",{"text":"Store"}]]],["textNode",{"text":". "}]]]]);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-dynamic-injection!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-template-loader!./components/store/templates/emptypurchase.tpl
// module id = 481
// module chunks = 4